import { cn } from '@/lib/utils'

export type SuggestionDomain = 'market' | 'business' | 'solution'

export interface Suggestion {
  id: string
  category: string
  domain: SuggestionDomain
  title: string
  description: string
}

interface Props {
  suggestion: Suggestion
  onApply: (s: Suggestion) => void
  onDismiss: (s: Suggestion) => void
  applying?: boolean
}

const DOMAIN_COLOR: Record<SuggestionDomain, string> = {
  market: 'var(--color-market)',
  business: 'var(--color-business)',
  solution: 'var(--color-solution)',
}

export function SkerpaSuggestionCard({ suggestion, onApply, onDismiss, applying }: Props) {
  const color = DOMAIN_COLOR[suggestion.domain]
  return (
    <div className="rounded-lg border border-border-subtle bg-white p-3.5 flex flex-col gap-2">
      <div className="flex items-center gap-1.5">
        <span className="inline-block h-1.5 w-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: color }} />
        <span className="text-[10px] font-semibold tracking-wider uppercase truncate" style={{ color }}>
          {suggestion.category}
        </span>
      </div>
      <div className="text-[13px] font-semibold text-text leading-snug">{suggestion.title}</div>
      <div className="text-[12px] text-text-secondary leading-relaxed">{suggestion.description}</div>
      <div className="flex items-center gap-2 pt-1">
        <button
          type="button"
          onClick={() => onApply(suggestion)}
          disabled={applying}
          className={cn(
            'rounded-md px-3 py-1.5 text-[12px] font-semibold transition-colors',
            'bg-text text-white hover:opacity-90',
            applying && 'opacity-60 cursor-wait'
          )}
        >
          {applying ? 'Applying…' : 'Apply'}
        </button>
        <button
          type="button"
          onClick={() => onDismiss(suggestion)}
          className="rounded-md border border-border-subtle bg-white px-3 py-1.5 text-[12px] font-medium text-text-secondary hover:bg-warm-50 transition-colors"
        >
          Dismiss
        </button>
      </div>
    </div>
  )
}
